export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10355.ab371360.jpg";